import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { SequenceEventCreate } from '@app/models/sequence-event.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-sequence-event-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class SequenceEventFormComponent {
  initialValue = input<SequenceEventCreate>();
  formChange = output<SequenceEventCreate>();
  formValid = output<boolean>();

  sequenceEventForm = new FormGroup<AutoForm<SequenceEventCreate>>({
    sequence_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
    event_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.sequenceEventForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.sequenceEventForm.valid);
    this.formChange.emit(<SequenceEventCreate>this.sequenceEventForm.value);
  }
}